import React, { useState } from "react";
import { Box } from "@mui/material";
import Layout from "../components/layout/Layout";

import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import { Button, MenuItem } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";

import { CustomerCategories } from "../dashboardRow";
import Company from "./Company";

const Kyc = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Layout >
      
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="KYC Details">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2, mt: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 200, height: 32, borderRadius: "0px" }}>
              Customer Category
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
        <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "ab2solute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {CustomerCategories.map((category, index) => {
          
          return (
            <MenuItem key={index} onClick={handleClose}>
              <Link
                to={`/${category.slug}`}
                style={{ textDecoration: "none", fontSize: "0.8rem" }}
                className="text-dark"
              >
                {category.name}
              </Link>
            </MenuItem>
          );
        })}
      </Menu>
      <Company />
    </Layout>
  );
};

export default Kyc;
